// src/services/api.js
import axios from 'axios';
import authService from './auth';

const REACT_APP_API_URL = 'https://decko.fr/api';

// Configuration de base pour axios
const api = axios.create({
    baseURL: REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});


// Services API

// Blog
export const blogService = {
    // Récupérer tous les articles
    getAll: async (params = {}) => {
        // Si aucun paramètre n'est spécifié, utilisez l'URL simple
        if (Object.keys(params).length === 0) {
            const response = await api.get('/blog');
            return response.data;
        }

        // Sinon, construisez l'URL vous-même pour éviter le problème
        const page = params.page || 1;
        const limit = params.limit || 10;
        // Ignorer les autres paramètres pour l'instant

        const response = await api.get(`/blog`);

        // Filtrer et paginer manuellement les résultats
        const allPosts = response.data.posts || [];
        const filteredPosts = (params.published !== undefined && params.published !== null)
            ? allPosts.filter(post => post.is_published === (params.published ? 1 : 0))
            : allPosts;

        const startIndex = (page - 1) * limit;
        const paginatedPosts = filteredPosts.slice(startIndex, startIndex + limit);

        return {
            posts: paginatedPosts,
            pagination: {
                current_page: page,
                per_page: limit,
                total_items: filteredPosts.length,
                total_pages: Math.ceil(filteredPosts.length / limit)
            }
        };
    },

    // Récupérer un article par son slug
    getBySlug: async (slug) => {
        const response = await api.get(`/blog/${slug}`);
        return response.data;
    },

    // Récupérer les articles par catégorie
    getByCategory: async (categorySlug) => {
        const response = await api.get(`/blog/category/${categorySlug}`);
        return response.data;
    },

    // Ajouter un article (admin)
    create: async (postData) => {
        const response = await api.post('/blog', postData);
        return response.data;
    },

    // Mettre à jour un article (admin)
    update: async (id, postData) => {
        const response = await api.put(`/blog/${id}`, postData);
        return response.data;
    },

    // Supprimer un article (admin)
    delete: async (id) => {
        const response = await api.delete(`/blog/${id}`);
        return response.data;
    },
};

// Réalisations
export const realizationsService = {
    // Récupérer toutes les réalisations
    getAll: async (params = {}) => {
        const response = await api.get('/realizations', { params });
        return response.data;
    },

    // Récupérer une réalisation par son ID
    getById: async (id) => {
        const response = await api.get(`/realizations/${id}`);
        return response.data;
    },

    // Récupérer les réalisations par catégorie
    getByCategory: async (categorySlug) => {
        const response = await api.get(`/realizations/category/${categorySlug}`);
        return response.data;
    },

    // Ajouter une réalisation (admin)
    create: async (realizationData) => {
        const response = await api.post('/realizations', realizationData);
        return response.data;
    },

    // Mettre à jour une réalisation (admin)
    update: async (id, realizationData) => {
        const response = await api.put(`/realizations/${id}`, realizationData);
        return response.data;
    },

    // Supprimer une réalisation (admin)
    delete: async (id) => {
        const response = await api.delete(`/realizations/${id}`);
        return response.data;
    },
};

// Catégories
export const categoriesService = {
    // Récupérer toutes les catégories
    getAll: async () => {
        const response = await api.get('/categories');
        return response.data;
    },

    // Récupérer une catégorie par son slug
    getBySlug: async (slug) => {
        const response = await api.get(`/categories/${slug}`);
        return response.data;
    },

    // Ajouter une catégorie (admin)
    create: async (categoryData) => {
        const response = await api.post('/categories', categoryData);
        return response.data;
    },

    // Mettre à jour une catégorie (admin)
    update: async (id, categoryData) => {
        const response = await api.put(`/categories/${id}`, categoryData);
        return response.data;
    },

    // Supprimer une catégorie (admin)
    delete: async (id) => {
        const response = await api.delete(`/categories/${id}`);
        return response.data;
    },
};

// Contact
export const contactService = {
    // Envoyer un message de contact
    sendMessage: async (contactData) => {
        const response = await api.post('/contact', contactData);
        return response.data;
    },
};

export const uploadService = {
    // Uploader une image
    // Dans votre fichier JavaScript
    // Fonction simplifiée pour uploader une image
    uploadImage: async (file) => {
        try {
            // Créer un FormData pour envoyer le fichier
            const formData = new FormData();
            formData.append('image', file);

            // Appeler votre endpoint d'upload d'image
            const response = await axios.post(
                `${REACT_APP_API_URL}/upload`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                }
            );

            // Retourner le nom du fichier uploadé
            if (response.data && response.data.filename) {
                return response.data.filename;
            }

            return null;
        } catch (error) {
            console.error('Erreur lors de l\'upload de l\'image:', error);
            return null;
        }
    }
};

export default api;